import styled from "styled-components/macro";
import { IStepperStyleProps } from "./types";

export const Container = styled.div<IStepperStyleProps>`
  display: flex;
  flex-direction: ${({ orientation }) => (orientation === "vertical" ? "column" : "row")};
`;
